export default "__VITE_ASSET__DuseuGHM__"